module.exports = __webpack_public_path__ + "static/media/report4.dcf66015.png";